import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FaFacebookF, FaTwitter } from "react-icons/fa"
import { FacebookShareButton, TwitterShareButton } from "react-share"

import withTranslation from "../i18n/withTranslation"

const Wrapper = styled.div`
  display: flex;
  button {
    font-family: "Gotham", Arial, sans-serif;
    background: black;
    padding: 18px;
    outline: none;
    border: none;
    appearance: none;
    cursor: pointer;
    transition: all 0.3s ease;
    color: white;
    text-transform: uppercase;

    .icon {
      transition: all 0.5s ease;
    }

    .text {
      display: none;
    }

    svg {
      color: white;
    }

    &[aria-label="facebook"]:hover {
      background: #3b5998;
    }

    &[aria-label="twitter"]:hover {
      background: #00acee;
    }

    &:hover {
      .icon {
        transform: translateY(-20%);
      }
    }
  }
`

const Share = ({ socialConfig, simple, t }) => (
  <Wrapper>
    {!simple && <button type="button">{t("blog.share")}</button>}
    <FacebookShareButton resetButtonStyle={false} url={socialConfig.config.url}>
      <FaFacebookF className="icon" />
      <span className="text">Facebook share</span>
    </FacebookShareButton>

    <TwitterShareButton
      url={socialConfig.config.url}
      resetButtonStyle={false}
      className="button is-outlined is-rounded twitter"
      title={socialConfig.config.title}
    >
      <FaTwitter className="icon" />
      <span className="text">Tweet</span>
    </TwitterShareButton>
  </Wrapper>
)

Share.propTypes = {
  socialConfig: PropTypes.shape({
    config: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
  simple: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

Share.defaultProps = {
  simple: false,
}

export default withTranslation(Share)
